import KizugawaBookingRoutesPage from './pages/management/KizugawaBookingRoutesPage';
import AnalysisNavigation, {AnalysisHome} from './pages/management/analysis/AnalysisNavigation';
import KizugawaBehaviorPage from "./pages/management/KizugawaBehaviorPage";
import KizugawaPages from "./pages/website/KizugawaPages";
import React, {
  useState,
  useMemo,
  useEffect,
  useRef,
  useLayoutEffect,
} from "react";
import {
  BrowserRouter,
  HashRouter,
  Route,
  Routes,
  Navigate,
  Link,
  useLocation,
} from "react-router-dom";
import "./styles/common.scss";
import { Menu, Icon, Header } from "semantic-ui-react";
import { useAuth } from "./contexts/AuthContext";
import LoadingSpinner from "./components/LoadingSpinner";
import SidebarAccount from "./components/SidebarAccount";
import TopPage from "./pages/management/TopPage";
import LoginPage from "./pages/auth/LoginPage";
import CustomerListPage from "./pages/management/CustomerListPage";
import FreeCustomerListPage from "./pages/management/FreeCustomerListPage";
import RemoveCustomerListPage from "./pages/management/RemoveCustomerListPage";
import UnpaidInvoiceListPage from "./pages/management/UnpaidInvoiceListPage";
import LateFeeIssuancePage from "./pages/management/LateFeeIssuancePage";
import SendMailPage from "./pages/management/SendMailPage";
import SegmentBroadcastPage from "./pages/management/SegmentBroadcastPage";
import ScenarioManagerPage from "./pages/management/ScenarioManagerPage";
import LineAnalyticsPage from "./pages/management/LineAnalyticsPage";
import RefundRosterPage from "./pages/management/RefundRosterPage";
import AccessQuestionnairePage from "./pages/management/AccessQuestionnairePage";
import Recital2025CustomerListPage from "./pages/management/recital/2025/CustomerListPage";
import Recital2025SeatPage from "./pages/management/recital/2025/SeatPage";
import Recital2025StudentSeatPage from "./pages/management/recital/2025/StudentSeatPage";
import Recital2025SpecialFeePage from "./pages/management/recital/2025/SpecialFeePage";
import Recital2025MusicEditPage from "./pages/management/recital/2025/MusicEditPage";
import Recital2025QuestionnairePage from "./pages/management/recital/2025/QuestionnairePage";
import Recital2025DiskOrderListPage from "./pages/management/recital/2025/DiskOrderListPage";

import Recital2027CustomerListPage from "./pages/management/recital/2027/CustomerListPage";
import Recital2027PickupAuditionPage from "./pages/management/recital/2027/PickupAuditionPage";
import Recital2027RehearsalSchedulePage from "./pages/management/recital/2027/RehearsalSchedulePage";
import Recital2027SpecialWorkPage from "./pages/management/recital/2027/SpecialWorkPage";
import Recital2027SeatOrderPage from "./pages/management/recital/2027/SeatOrderPage";
import Recital2027SeatAssignPage from "./pages/management/recital/2027/SeatAssignPage";
import Recital2027MediaSubmissionPage from "./pages/management/recital/2027/MediaSubmissionPage";
import Recital2027TimetablePage from "./pages/management/recital/2027/TimetablePage";

import Recital2026CustomerListPage from "./pages/management/recital/2026/CustomerListPage";
import Recital2026SeatPage from "./pages/management/recital/2026/SeatPage";
import Recital2026MusicAndPlanPage from "./pages/management/recital/2026/MusicAndPlanPage";
import Recital2026HoodieOrderListPage from "./pages/management/recital/2026/HoodieOrderListPage";
import Recital2026SpecialFeePage from "./pages/management/recital/2026/SpecialFeePage";
import Recital2026DiskOrderListPage from "./pages/management/recital/2026/DiskOrderListPage";

import OrderListPage from "./pages/management/OrderListPage";
import OrderPrintListPage from "./pages/management/OrderPrintListPage";
import RestockPage from "./pages/management/RestockPage";
import OpenNoticePage from "./pages/management/OpenNoticePage";
import SalaryPage from "./pages/management/SalaryPage";
import RentManagementPage from './pages/management/RentManagementPage';
import KizugawaAnalyticsPage from "./pages/management/KizugawaAnalyticsPage";
import FinanceWorkspace from "./components/FinanceWorkspace";
import FinancePage, { CashFlowPage } from "./pages/management/FinancePage";
import SalaryConfirmPage from "./pages/management/SalaryConfirmPage";
import SalaryStatementsPage from "./pages/management/SalaryStatementsPage";
import WsPatt2509RequestsPage from "./pages/management/WsPatt2509RequestsPage";
import LpAnalyticsPage from "./pages/management/LpAnalyticsPage";
import LpBehaviorPage from "./pages/management/LpBehaviorPage";
import TrialAnalyticsPage from "./pages/management/TrialAnalyticsPage";
import EnrollmentAdvicePage from "./pages/management/EnrollmentAdvicePage";
import MetaAdsPage from "./pages/management/MetaAdsPage";
import KizugawaAdReportsPage from "./pages/management/KizugawaAdReportsPage";
import EmployeeAttendancePage from "./pages/employee/AttendancePage";
import EmployeeShiftManagementPage from "./pages/employee/ShiftManagementPage";
import EmployeeLeaveApprovalPage from "./pages/employee/LeaveApprovalPage";
import EmployeeTimeCorrectionApprovalPage from "./pages/employee/TimeCorrectionApprovalPage";
import EmployeeMypageHome from "./pages/employee/MypageHome";
import EmployeePayslipPage from "./pages/employee/PayslipPage";
import EmployeeOvertimeApprovalPage from "./pages/employee/OvertimeApprovalPage";
import EmployeePayslipAdminPage from "./pages/employee/PayslipAdminPage";
import EmployeeTodoBoardPage from "./pages/employee/TodoBoardPage";
import EmployeeApplyHubPage from "./pages/employee/ApplyHubPage";
import KozSecretAudition26Page from "./pages/management/KozSecretAudition26Page";
import JypSecretAudition26Page from "./pages/management/JypSecretAudition26Page";
import SmSecretAudition26Page from "./pages/management/SmSecretAudition26Page";
import DanceCamp26ShiftPage from "./pages/management/DanceCamp26ShiftPage";
import DanceCamp26ParticipantsPage from "./pages/management/DanceCamp26ParticipantsPage";
import MonthlyLessonParticipantsPage from "./pages/management/MonthlyLessonParticipantsPage";
import WebsiteManagementPage from "./pages/website/WebsiteManagementPage";
import StudioListPage from "./pages/website/studio/StudioListPage";
import StudioEditPage from "./pages/website/studio/StudioEditPage";
import InstructorListPage from "./pages/website/instructor/InstructorListPage";
import InstructorEditPage from "./pages/website/instructor/InstructorEditPage";
import LessonCancellationPage from "./pages/website/lesson/LessonCancellationPage";
import ExternalEventsPage from "./pages/website/externalEvents/ExternalEventsPage";
import LessonLocationListPage from "./pages/website/lessonLocation/LessonLocationListPage";
import NewsListPage from "./pages/website/news/NewsListPage";
import NewsEditPage from "./pages/website/news/NewsEditPage";
import VisualPage from "./pages/website/visual/VisualPage";
import QaPage from "./pages/website/qa/QaPage";
import FaqListPage from "./pages/website/faq/FaqListPage";
import FaqEditPage from "./pages/website/faq/FaqEditPage";
import AnalyticsPage from "./pages/website/analytics/AnalyticsPage";
import CampaignListPage from "./pages/website/campaign/CampaignListPage";
import CampaignEditPage from "./pages/website/campaign/CampaignEditPage";
import ReviewPage from "./pages/website/review/ReviewPage";
import useBodyClass from "./hooks/useBodyClass";
import ChatPage from "./pages/mypage/chat/ChatPage";
import BroadcastMessageListPage from "./pages/mypage/broadcast-message/BroadcastMessageListPage";
import BroadcastMessageEditPage from "./pages/mypage/broadcast-message/BroadcastMessageEditPage";

function App() {
  const { isLoggedIn, logout, financePermissions } = useAuth();

  const handleLogout = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await fetch(`${apiUrl}/api/logout/`);
      if (!response.ok) {
        throw new Error("ネットワークレスポンスが異常です。");
      }
      const data = await response.json();
      console.log(data);
      await logout();
      window.location.href = "/login";
    } catch (error) {
      alert("ログアウトに失敗しました。");
    }
  };

  const toggleSidebar = () => {
    const sidebar = document.querySelector(".sidebar");
    const overlay = document.querySelector(".sidebar-overlay");
    if (sidebar && overlay) {
      sidebar.classList.toggle("open");
      overlay.classList.toggle("open");
    }
  };

  const closeSidebar = () => {
    const sidebar = document.querySelector(".sidebar");
    const overlay = document.querySelector(".sidebar-overlay");
    if (sidebar && overlay) {
      sidebar.classList.remove("open");
      overlay.classList.remove("open");
    }
  };

  const SidebarLayout = ({ children, menuType }) => {
    const location = useLocation();

    // 管理画面
    const managementMenu = useMemo(
      () => (
        <NavNodes
          nodes={MANAGEMENT_NAV.filter(item=>!item.financePermission || (isLoggedIn && financePermissions?.[item.financePermission]===true))}
          variant="top"
          pathname={location.pathname}
          onLinkClick={closeSidebar}
          onLogout={handleLogout}
        />
      ),
      [location.pathname, closeSidebar, isLoggedIn, financePermissions]
    );

    // WEBサイト管理
    const websiteMenu = useMemo(
      () => (
        <>
          <Menu.Item
            as={Link}
            to="/website/studio-list"
            className={location.pathname === "/website/studio-list" ? "on" : ""}
            onClick={closeSidebar}
          >
            <Icon name="building" />
            <span> スタジオ</span>
          </Menu.Item>
          <Menu.Item
            as={Link}
            to="/website/instructor-list"
            className={
              location.pathname === "/website/instructor-list" ? "on" : ""
            }
            onClick={closeSidebar}
          >
            <Icon name="child" />
            <span> インストラクター</span>
          </Menu.Item>
          <Menu.Item
            as={Link}
            to="/website/visual"
            className={location.pathname === "/website/visual" ? "on" : ""}
            onClick={closeSidebar}
          >
            <Icon name="camera" />
            <span> 写真 / 動画</span>
          </Menu.Item>
          <Menu.Item
            as={Link}
            to="/website/qa"
            className={location.pathname === "/website/qa" ? "on" : ""}
            onClick={closeSidebar}
          >
            <Icon name="question" />
            <span>Q & A</span>
          </Menu.Item>
          <Menu.Item
            as={Link}
            to="/website/faq-list"
            className={location.pathname === "/website/faq-list" ? "on" : ""}
            onClick={closeSidebar}
          >
            <Icon name="question" />
            <span>よくある質問</span>
          </Menu.Item>
          <Menu.Item
            as={Link}
            to="/website/news-list"
            className={location.pathname === "/website/news-list" ? "on" : ""}
            onClick={closeSidebar}
          >
            <Icon name="edit" />
            <span>投稿</span>
          </Menu.Item>
          <Menu.Item
            as={Link}
            to="/website/review"
            className={location.pathname === "/website/review" ? "on" : ""}
            onClick={closeSidebar}
          >
            <Icon name="comment" />
            <span> 口コミ</span>
          </Menu.Item>
          <Menu.Item as={Link} to="/website/kizugawa-pages" onClick={closeSidebar}><Icon name="file alternate" /><span>木津川 LP</span></Menu.Item>
          <Menu.Item
            as={Link}
            to="/website/campaign-list"
            className={
              location.pathname === "/website/campaign-list" ? "on" : ""
            }
            onClick={closeSidebar}
          >
            <Icon name="bullhorn" />
            <span>キャンペーン</span>
          </Menu.Item>
          <Menu.Item
            as={Link}
            to="/website/analytics"
            className={location.pathname === "/website/analytics" ? "on" : ""}
            onClick={closeSidebar}
          >
            <Icon name="chart bar" />
            <span> 解析</span>
          </Menu.Item>
          <Menu.Item as={Link} to="/">
            <Icon name="arrow left" />
            <span> 管理画面に戻る</span>
          </Menu.Item>
        </>
      ),
      [location.pathname, closeSidebar]
    );

    return location.pathname === "/management/order-print-list" ? (
      children
    ) : (
      <>
        <Header className="top" textAlign="left">
          <button className="hamburger-menu" onClick={toggleSidebar}>
            <span></span>
            <span></span>
            <span></span>
          </button>
          SLASH ADMIN
        </Header>
        <LoadingSpinner />
        <main>
          <div className="sidebar">
            <button className="close-sidebar" onClick={closeSidebar}>
              ×
            </button>
            <div className="sidebar-scroll">
              {menuType === "management" && managementMenu}
              {menuType === "website" && websiteMenu}
            </div>
            {/* 最下部のアカウント＝勤怠マイページ(Guluu 勤怠)への入口。
                メニュー(.sidebar-scroll)だけがスクロールし、この入口は常にサイドバー底に固定される。 */}
            <SidebarAccount onNavigate={closeSidebar} />
          </div>
          <div className="sidebar-overlay" onClick={closeSidebar}></div>
          <div className="inner"><AnalysisNavigation/>{children}</div>
        </main>
      </>
    );
  };

  const RenderPage = () => {
    useBodyClass();

    // 共有リンク: /external-events?key=... は未ログインでも通す。鍵の正誤は slash-app
    // 側（shared エンドポイント）が判定するので、鍵をJSに焼き込まないためここでは
    // 「?key= の有無」だけを見る。データ取得も鍵で認証されるため空表示にならない。
    const location = useLocation();
    const hasExternalEventsShareKey =
      location.pathname === "/external-events" &&
      Boolean(new URLSearchParams(location.search).get("key"));

    if (!isLoggedIn && !hasExternalEventsShareKey) {
      return <Navigate to="/login" replace />;
    }

    return (
      <Routes>
        <Route
          path="/"
          element={
            <SidebarLayout menuType="management">
              <TopPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/customer-list"
          element={
            <SidebarLayout menuType="management">
              <CustomerListPage />
            </SidebarLayout>
          }
        />
        {/* 勤怠マイページ（Porcelainテーマ・SLASH ADMINとは別レイアウトでフル表示） */}
        {/* 勤怠マイページ（Porcelain）。各ページが MypageLayout を内包するため SidebarLayout で包まない。 */}
        <Route path="/employee" element={<EmployeeMypageHome />} />
        <Route path="/employee/attendance" element={<EmployeeAttendancePage />} />
        <Route path="/employee/shift" element={<EmployeeShiftManagementPage />} />
        <Route path="/employee/todo" element={<EmployeeTodoBoardPage />} />
        <Route path="/employee/apply" element={<EmployeeApplyHubPage />} />
        {/* 旧・申請/カレンダーの個別ルートは申請ハブ／ホームへリダイレクト（URL互換・真っ白防止）。 */}
        <Route path="/employee/leave" element={<Navigate to="/employee/apply?tab=leave" replace />} />
        <Route path="/employee/time-correction" element={<Navigate to="/employee/apply?tab=correction" replace />} />
        <Route path="/employee/overtime" element={<Navigate to="/employee/apply?tab=overtime" replace />} />
        <Route path="/employee/calendar" element={<Navigate to="/employee" replace />} />
        <Route path="/employee/payslip" element={<EmployeePayslipPage />} />
        <Route path="/employee/payslip-admin" element={<EmployeePayslipAdminPage />} />
        {/* 休み/時間訂正の承認（Porcelain・MypageLayout内包のため bare） */}
        <Route path="/employee/leave-approval" element={<EmployeeLeaveApprovalPage />} />
        <Route path="/employee/time-correction-approval" element={<EmployeeTimeCorrectionApprovalPage />} />
        {/* 残業の承認（Porcelain・MypageLayout内包のため bare） */}
        <Route path="/employee/overtime-approval" element={<EmployeeOvertimeApprovalPage />} />
        <Route
          path="/management/free-customer-list"
          element={
            <SidebarLayout menuType="management">
              <FreeCustomerListPage />
            </SidebarLayout>
          }
        />
        <Route path="/management/analytics" element={<SidebarLayout menuType="management"><AnalysisHome scope="overall"/></SidebarLayout>} />
        <Route path="/management/kizugawa" element={<SidebarLayout menuType="management"><AnalysisHome scope="kizugawa"/></SidebarLayout>} />
        <Route
          path="/management/lp-analytics"
          element={
            <SidebarLayout menuType="management">
              <LpAnalyticsPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/lp-behavior"
          element={
            <SidebarLayout menuType="management">
              <LpBehaviorPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/trial-analytics"
          element={
            <SidebarLayout menuType="management">
              <TrialAnalyticsPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/enrollment-advice"
          element={
            <SidebarLayout menuType="management">
              <EnrollmentAdvicePage />
            </SidebarLayout>
          }
        />
        <Route path="/management/kizugawa-behavior" element={<SidebarLayout menuType="management"><KizugawaBehaviorPage /></SidebarLayout>} />
        <Route path="/management/kizugawa-ad-reports" element={<SidebarLayout menuType="management"><KizugawaAdReportsPage /></SidebarLayout>} />
        <Route
          path="/management/meta-ads"
          element={
            <SidebarLayout menuType="management">
              <MetaAdsPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/unpaid-invoice-list"
          element={
            <SidebarLayout menuType="management">
              <UnpaidInvoiceListPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/late-fee-issuance"
          element={
            <SidebarLayout menuType="management">
              <LateFeeIssuancePage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/remove-customer-list"
          element={
            <SidebarLayout menuType="management">
              <RemoveCustomerListPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/send-mail"
          element={
            <SidebarLayout menuType="management">
              <SendMailPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/line-broadcast"
          element={
            <SidebarLayout menuType="management">
              <SegmentBroadcastPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/line-scenarios"
          element={
            <SidebarLayout menuType="management">
              <ScenarioManagerPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/line-analytics"
          element={
            <SidebarLayout menuType="management">
              <LineAnalyticsPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/refund-roster"
          element={
            <SidebarLayout menuType="management">
              <RefundRosterPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/access-questionnaire"
          element={
            <SidebarLayout menuType="management">
              <AccessQuestionnairePage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/recital/2025/customer-list"
          element={
            <SidebarLayout menuType="management">
              <Recital2025CustomerListPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/recital/2025/seat"
          element={
            <SidebarLayout menuType="management">
              <Recital2025SeatPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/recital/2025/student-seat"
          element={
            <SidebarLayout menuType="management">
              <Recital2025StudentSeatPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/recital/2025/special-fee"
          element={
            <SidebarLayout menuType="management">
              <Recital2025SpecialFeePage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/recital/2025/music-edit"
          element={
            <SidebarLayout menuType="management">
              <Recital2025MusicEditPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/recital/2025/questionnaire"
          element={
            <SidebarLayout menuType="management">
              <Recital2025QuestionnairePage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/recital/2025/disk-order-list"
          element={
            <SidebarLayout menuType="management">
              <Recital2025DiskOrderListPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/recital/2027/customer-list"
          element={
            <SidebarLayout menuType="management">
              <Recital2027CustomerListPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/recital/2027/pickup-audition"
          element={
            <SidebarLayout menuType="management">
              <Recital2027PickupAuditionPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/recital/2027/rehearsal-schedule"
          element={
            <SidebarLayout menuType="management">
              <Recital2027RehearsalSchedulePage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/recital/2027/special-work"
          element={
            <SidebarLayout menuType="management">
              <Recital2027SpecialWorkPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/recital/2027/timetable"
          element={
            <SidebarLayout menuType="management">
              <Recital2027TimetablePage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/recital/2027/seat-order"
          element={
            <SidebarLayout menuType="management">
              <Recital2027SeatOrderPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/recital/2027/seat-assign"
          element={
            <SidebarLayout menuType="management">
              <Recital2027SeatAssignPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/recital/2027/media-submission"
          element={
            <SidebarLayout menuType="management">
              <Recital2027MediaSubmissionPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/recital/2026/customer-list"
          element={
            <SidebarLayout menuType="management">
              <Recital2026CustomerListPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/recital/2026/seat"
          element={
            <SidebarLayout menuType="management">
              <Recital2026SeatPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/recital/2026/music-and-plan"
          element={
            <SidebarLayout menuType="management">
              <Recital2026MusicAndPlanPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/recital/2026/hoodie-order-list"
          element={
            <SidebarLayout menuType="management">
              <Recital2026HoodieOrderListPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/recital/2026/special-fee"
          element={
            <SidebarLayout menuType="management">
              <Recital2026SpecialFeePage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/recital/2026/disk-order-list"
          element={
            <SidebarLayout menuType="management">
              <Recital2026DiskOrderListPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/order-list"
          element={
            <SidebarLayout menuType="management">
              <OrderListPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/order-print-list"
          element={
            <SidebarLayout menuType="management">
              <OrderPrintListPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/restock"
          element={
            <SidebarLayout menuType="management">
              <RestockPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/open-notice"
          element={
            <SidebarLayout menuType="management">
              <OpenNoticePage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/rents"
          element={<FinanceWorkspace permission="rents"><RentManagementPage /></FinanceWorkspace>}
        />
        <Route
          path="/management/kizugawa-booking-routes"
          element={<FinanceWorkspace permission="finance"><KizugawaBookingRoutesPage /></FinanceWorkspace>}
        />
        <Route
          path="/management/kizugawa-analytics"
          element={<FinanceWorkspace permission="finance"><KizugawaAnalyticsPage /></FinanceWorkspace>}
        />
        <Route
          path="/management/cashflow"
          element={<FinanceWorkspace permission="finance"><CashFlowPage /></FinanceWorkspace>}
        />
        <Route
          path="/management/finance"
          element={<SidebarLayout menuType="management"><FinancePage /></SidebarLayout>}
        />
        <Route
          path="/management/salary"
          element={
            <SidebarLayout menuType="management">
              <SalaryPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/salary/confirm"
          element={
            <SidebarLayout menuType="management">
              <SalaryConfirmPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/salary/statements"
          element={
            <SidebarLayout menuType="management">
              <SalaryStatementsPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/ws-patt-2509-requests"
          element={
            <SidebarLayout menuType="management">
              <WsPatt2509RequestsPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/koz-secret-audition-26"
          element={
            <SidebarLayout menuType="management">
              <KozSecretAudition26Page />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/jyp-secret-audition-26"
          element={
            <SidebarLayout menuType="management">
              <JypSecretAudition26Page />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/sm-secret-audition-26"
          element={
            <SidebarLayout menuType="management">
              <SmSecretAudition26Page />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/dance-camp-26/shift"
          element={
            <SidebarLayout menuType="management">
              <DanceCamp26ShiftPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/dance-camp-26/participants"
          element={
            <SidebarLayout menuType="management">
              <DanceCamp26ParticipantsPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/monthly-lesson-participants"
          element={
            <SidebarLayout menuType="management">
              <MonthlyLessonParticipantsPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/website/website-management"
          element={
            <SidebarLayout menuType="website">
              <WebsiteManagementPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/website/studio-list"
          element={
            <SidebarLayout menuType="website">
              <StudioListPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/website/studio-edit/:studioId"
          element={
            <SidebarLayout menuType="website">
              <StudioEditPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/website/instructor-list"
          element={
            <SidebarLayout menuType="website">
              <InstructorListPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/website/instructor-edit/:instructorId"
          element={
            <SidebarLayout menuType="website">
              <InstructorEditPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/website/lesson-cancellations"
          element={
            <SidebarLayout menuType="management">
              <LessonCancellationPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/external-events"
          element={
            <SidebarLayout menuType="management">
              <ExternalEventsPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/management/lesson-location-list"
          element={
            <SidebarLayout menuType="management">
              <LessonLocationListPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/website/visual"
          element={
            <SidebarLayout menuType="website">
              <VisualPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/website/qa"
          element={
            <SidebarLayout menuType="website">
              <QaPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/website/faq-list"
          element={
            <SidebarLayout menuType="website">
              <FaqListPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/website/faq-edit/:id?"
          element={
            <SidebarLayout menuType="website">
              <FaqEditPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/website/news-list"
          element={
            <SidebarLayout menuType="website">
              <NewsListPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/website/news-edit/:id?"
          element={
            <SidebarLayout menuType="website">
              <NewsEditPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/website/review"
          element={
            <SidebarLayout menuType="website">
              <ReviewPage />
            </SidebarLayout>
          }
        />
        <Route path="/website/kizugawa-pages/:id?" element={<SidebarLayout menuType="website"><KizugawaPages /></SidebarLayout>} />
        <Route
          path="/website/campaign-list"
          element={
            <SidebarLayout menuType="website">
              <CampaignListPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/website/campaign-edit/:id?"
          element={
            <SidebarLayout menuType="website">
              <CampaignEditPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/website/analytics"
          element={
            <SidebarLayout menuType="website">
              <AnalyticsPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/mypage/chat"
          element={
            <SidebarLayout menuType="management">
              <ChatPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/mypage/broadcast-message-list"
          element={
            <SidebarLayout menuType="management">
              <BroadcastMessageListPage />
            </SidebarLayout>
          }
        />
        <Route
          path="/mypage/broadcast-message-edit/:id?"
          element={
            <SidebarLayout menuType="management">
              <BroadcastMessageEditPage />
            </SidebarLayout>
          }
        />
      </Routes>
    );
  };

  // 通常/本番ビルドは BrowserRouter（従来どおり root）。
  // デモビルド（REACT_APP_DEMO=1）だけ HashRouter にして、サブパス /uidemo/ 配下でも
  // サーバのSPAフォールバック設定に依存せず動く（ルートは URL のハッシュ部で管理）。
  const isDemo = process.env.REACT_APP_DEMO === "1";
  const Router = isDemo ? HashRouter : BrowserRouter;
  return (
    <Router basename={isDemo ? undefined : (process.env.PUBLIC_URL || undefined)}>
      <div className="App">
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="*" element={<RenderPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;

// ============================================================
// 左サイドバー（管理画面）のナビゲーション定義
// - category : トップの大分類。展開すると通常項目(link)やサブグループ(group)を表示
// - group    : 開閉できるサブメニュー。末端リンク(li)を内包する
// - link      : 単体リンク（path を持つ）
// - action    : ログアウト等のアクション
// startsWith を指定するとその接頭辞でアクティブ判定する。
// ============================================================
const MANAGEMENT_NAV = [
  { label: "全体分析", icon: "chart line", path: "/management/analytics" },
  { label: "木津川校", icon: "building", path: "/management/kizugawa" },
  { label: "家賃・スタジオ代", icon: "building", path: "/management/rents", financePermission: "rents" },
  { label: "ダッシュボード", icon: "dashboard", path: "/" },

  {
    kind: "category",
    label: "生徒管理",
    icon: "users",
    children: [
      { label: "生徒一覧", icon: "users", path: "/management/customer-list" },
      {
        label: "体験申込者一覧",
        icon: "clipboard list",
        path: "/management/free-customer-list",
      },
      {
        label: "マンスリーレッスン",
        icon: "calendar check",
        path: "/management/monthly-lesson-participants",
      },
      {
        label: "退会者一覧",
        icon: "user delete",
        path: "/management/remove-customer-list",
      },
      {
        kind: "group",
        label: "未払い管理",
        icon: "exclamation triangle",
        children: [
          { label: "未払い者一覧", path: "/management/unpaid-invoice-list" },
          { label: "延滞金発行管理", path: "/management/late-fee-issuance" },
        ],
      },
      { label: "問い合わせ", icon: "mail", path: "/mypage/chat" },
      {
        label: "予約開始リクエスト",
        icon: "calendar",
        path: "/management/open-notice",
      },
    ],
  },

  {label:"アクセスアンケート",icon:"train",path:"/management/access-questionnaire"},

  {
    kind: "category",
    label: "レッスン",
    icon: "calendar alternate",
    children: [
      {
        label: "休校振替管理",
        icon: "calendar check",
        path: "/website/lesson-cancellations",
      },
      {
        label: "レッスン会場",
        icon: "map marker alternate",
        path: "/management/lesson-location-list",
        startsWith: "/management/lesson-location",
      },
    ],
  },

  // 本番での関係者向け公開は保留中。動作確認後に解除する（ルート/ページは有効）。
  // {
  //   kind: "category",
  //   label: "インストラクター",
  //   icon: "user",
  //   children: [
  //     {
  //       label: "外部イベント出演申請",
  //       icon: "instagram",
  //       path: "/external-events",
  //     },
  //   ],
  // },

  {
    kind: "category",
    label: "発表会",
    icon: "music",
    children: [
      {
        kind: "group",
        label: "発表会2027",
        icon: "music",
        children: [
          {
            label: "参加者一覧",
            path: "/management/recital/2027/customer-list",
            target: "",
          },
          {
            label: "オーディション参加者",
            path: "/management/recital/2027/pickup-audition",
            target: "",
          },
          {
            label: "リハーサル日程",
            path: "/management/recital/2027/rehearsal-schedule",
            target: "",
          },
          {
            label: "特別ナンバー",
            path: "/management/recital/2027/special-work",
            target: "",
          },
          {
            label: "指定席の抽選申込",
            path: "/management/recital/2027/seat-order",
            target: "",
          },
          {
            label: "座席割当",
            path: "/management/recital/2027/seat-assign",
            target: "",
          },
          {
            label: "音源の提出状況",
            path: "/management/recital/2027/media-submission",
            target: "",
          },
          {
            label: "タイムテーブル",
            path: "/management/recital/2027/timetable",
            target: "",
          },
        ],
      },
      {
        kind: "group",
        label: "発表会2026",
        icon: "music",
        children: [
          {
            label: "参加者一覧",
            path: "/management/recital/2026/customer-list",
            target: "",
          },
          {
            label: "タイムテーブル",
            path: "https://staff.dance-slash.com/guluu/recital/sort_perform?year=2026",
            target: "_blank",
          },
          {
            label: "点呼表",
            path: "https://staff.dance-slash.com/guluu/recital/rollcall?year=2026",
            target: "_blank",
          },
          {
            label: "座席管理",
            path: "/management/recital/2026/seat",
            target: "",
          },
          {
            label: "音源・照明プラン管理",
            path: "https://dance-slash.com/recital2026/music_and_plan",
            target: "_blank",
          },
          {
            label: "アパレル注文一覧",
            path: "/management/recital/2026/hoodie-order-list",
            target: "",
          },
          {
            label: "アパレル購入ページ",
            path: "https://dance-slash.com/store/recital2026",
            target: "_blank",
          },
          {
            label: "イントラ給料",
            path: "/management/recital/2026/special-fee",
            target: "",
          },
          {
            label: "DVD購入者一覧",
            path: "/management/recital/2026/disk-order-list",
            target: "",
          },
          {
            label: "貼紙印刷用ページ",
            path: "https://staff.dance-slash.com/guluu/recital2026/print_seat",
            target: "_blank",
          },
        ],
      },
      {
        kind: "group",
        label: "発表会2025",
        icon: "music",
        children: [
          {
            label: "参加者一覧",
            path: "/management/recital/2025/customer-list",
            target: "",
          },
          {
            label: "座席管理",
            path: "/management/recital/2025/seat",
            target: "",
          },
          {
            label: "生徒座席管理",
            path: "/management/recital/2025/student-seat",
            target: "",
          },
          {
            label: "タイムテーブル",
            path: "https://staff.dance-slash.com/guluu/recital/sort_perform?year=2025",
            target: "_blank",
          },
          {
            label: "点呼表",
            path: "https://staff.dance-slash.com/guluu/recital/rollcall?year=2025",
            target: "_blank",
          },
          {
            label: "イントラ給料",
            path: "/management/recital/2025/special-fee",
            target: "",
          },
          {
            label: "イントラ音編",
            path: "/management/recital/2025/music-edit",
            target: "",
          },
          {
            label: "アンケート管理",
            path: "/management/recital/2025/questionnaire",
            target: "",
          },
          {
            label: "DVD購入者一覧",
            path: "/management/recital/2025/disk-order-list",
            target: "",
          },
          {
            label: "貼紙印刷用ページ",
            path: "https://staff.dance-slash.com/guluu/recital2025/print_seat",
            target: "_blank",
          },
        ],
      },
    ],
  },

  {
    kind: "category",
    label: "イベント",
    icon: "fire",
    children: [
      {
        kind: "group",
        label: "DANCE CAMP 2026",
        icon: "fire",
        children: [
          {
            label: "イントラ申込状況",
            path: "/management/dance-camp-26/shift",
            target: "",
          },
          {
            label: "参加者一覧",
            path: "/management/dance-camp-26/participants",
            target: "",
          },
        ],
      },
      {
        kind: "group",
        label: "オーディション",
        icon: "users",
        children: [
          {
            label: "KOZオーディション26",
            path: "/management/koz-secret-audition-26",
            target: "",
          },
          {
            label: "JYPオーディション26",
            path: "/management/jyp-secret-audition-26",
            target: "",
          },
          {
            label: "SMオーディション26",
            path: "/management/sm-secret-audition-26",
            target: "",
          },
        ],
      },
    ],
  },

  {
    kind: "category",
    label: "お知らせ・連絡",
    icon: "announcement",
    children: [
      { label: "メール送信", icon: "mail", path: "/management/send-mail" },
      {
        label: "一斉送信",
        icon: "announcement",
        path: "/mypage/broadcast-message-list",
      },
    ],
  },

  {
    kind: "group",
    label: "給与管理",
    icon: "yen sign",
    children: [
      { label: "給与確定", path: "/management/salary/confirm" },
      { label: "給与明細アップロード", path: "/management/salary/statements" },
      { label: "給与一覧", path: "/management/salary" },
    ],
  },

  {
    kind: "group",
    label: "オンラインストア",
    icon: "shopping cart",
    children: [
      { label: "注文一覧", path: "/management/order-list" },
      { label: "注文一覧（印刷用）", path: "/management/order-print-list" },
      { label: "再入荷リクエスト", path: "/management/restock" },
    ],
  },

  {
    kind: "category",
    label: "LINE配信",
    icon: "comments",
    children: [
      {
        label: "セグメント配信",
        icon: "paper plane",
        path: "/management/line-broadcast",
      },
      {
        label: "シナリオ管理",
        icon: "sitemap",
        path: "/management/line-scenarios",
      },
      {
        label: "配信分析",
        icon: "chart bar",
        path: "/management/line-analytics",
      },
    ],
  },

  { label: "WEBサイト管理", icon: "desktop", path: "/website/studio-list" },

  { kind: "action", label: "ログアウト", icon: "log out" },
];

const isNavLinkActive = (node, pathname) =>
  !!node.path &&
  (node.startsWith
    ? pathname.startsWith(node.startsWith)
    : pathname === node.path);

const navHasActiveDescendant = (node, pathname) =>
  (node.children || []).some((child) =>
    child.children
      ? navHasActiveDescendant(child, pathname)
      : isNavLinkActive(child, pathname)
  );

// サイドバーのノード群を再帰的に描画する。
// variant="top"  : アイコン＋ラベルの通常行（トップ項目 / カテゴリ直下の項目）
// variant="child": 末端リンク（li。サブグループ内の項目）
function NavNodes({ nodes, variant, pathname, onLinkClick, onLogout }) {
  // このリスト（兄弟）内で開けるグループは常に1つ＝アコーディオン。
  // アクティブなルートを含むグループを初期選択し、ページ遷移にも追従する。
  const activeIndex = nodes.findIndex(
    (n) => n.children && navHasActiveDescendant(n, pathname)
  );
  const [openIndex, setOpenIndex] = useState(activeIndex);
  const prevActiveIndex = useRef(activeIndex);

  useEffect(() => {
    // 遷移で別グループ内のページがアクティブになったら、それを開く（他は閉じる）。
    if (activeIndex !== -1 && activeIndex !== prevActiveIndex.current) {
      setOpenIndex(activeIndex);
    }
    prevActiveIndex.current = activeIndex;
  }, [activeIndex]);

  return nodes.map((node, index) => {
    if (node.kind === "action") {
      return (
        <Menu.Item
          as="a"
          key={index}
          onClick={() => {
            onLogout();
            onLinkClick();
          }}
        >
          <Icon name={node.icon} />
          <span>{node.label}</span>
        </Menu.Item>
      );
    }

    if (node.children) {
      return (
        <NavGroup
          key={index}
          node={node}
          isOpen={openIndex === index}
          // 開いているものをもう一度押したら閉じる。別のものを押したら切り替える。
          onToggle={() =>
            setOpenIndex((cur) => (cur === index ? -1 : index))
          }
          pathname={pathname}
          onLinkClick={onLinkClick}
          onLogout={onLogout}
        />
      );
    }

    const active = isNavLinkActive(node, pathname);

    if (variant === "child") {
      return (
        <Link
          to={node.path}
          target={node.target || undefined}
          className={`nav-leaf${active ? " on" : ""}`}
          key={index}
          onClick={onLinkClick}
        >
          <li>{node.label}</li>
        </Link>
      );
    }

    return (
      <Menu.Item
        as={Link}
        to={node.path}
        target={node.target || undefined}
        className={active ? "on" : ""}
        key={index}
        onClick={onLinkClick}
      >
        {node.icon && <Icon name={node.icon} />}
        <span>{node.label}</span>
      </Menu.Item>
    );
  });
}

// 開閉できるカテゴリ / サブグループ（開閉状態は親 NavNodes が単一管理）。
// 高さは中身の実寸(px)⇄0 でアニメーションする。grid の fr アニメは Chromium で
// collapse(1fr→0fr)が固着する不具合があるため使わない。開いている間は ResizeObserver で
// 入れ子（サブグループ）の伸縮に追従し、常に実寸まで開く＝クリップされない。
function NavGroup({ node, isOpen, onToggle, pathname, onLinkClick, onLogout }) {
  const isCategory = node.kind === "category";
  const ulRef = useRef(null);
  const innerRef = useRef(null);
  const openRef = useRef(isOpen);

  // 自身の開閉：実寸px ⇄ 0 でアニメーション。
  useLayoutEffect(() => {
    const ul = ulRef.current;
    const inner = innerRef.current;
    if (!ul || !inner) return;
    openRef.current = isOpen;
    ul.style.height = isOpen ? `${inner.offsetHeight}px` : "0px";
  }, [isOpen]);

  // 入れ子の開閉に追従：開いている間、inner の高さ変化に合わせて
  // トランジションなしで即時に高さを更新する（実寸まで必ず開く／親がゴム化しない）。
  useEffect(() => {
    const ul = ulRef.current;
    const inner = innerRef.current;
    if (!ul || !inner || typeof ResizeObserver === "undefined") return;
    const ro = new ResizeObserver(() => {
      if (!openRef.current) return;
      const saved = ul.style.transition;
      ul.style.transition = "none";
      ul.style.height = `${inner.offsetHeight}px`;
      void ul.offsetHeight; // reflow
      ul.style.transition = saved;
    });
    ro.observe(inner);
    return () => ro.disconnect();
  }, []);

  return (
    <>
      <Menu.Item
        className={`accordion-item${isOpen ? " open" : ""}`}
        onClick={onToggle}
      >
        {node.icon && <Icon name={node.icon} />}
        <span>{node.label}</span>
        <Icon className="nav-caret" name="angle down" />
      </Menu.Item>
      <ul ref={ulRef} className={`children${isCategory ? " nav-cat" : ""}`}>
        <div className="children-inner" ref={innerRef}>
          <NavNodes
            nodes={node.children}
            variant={isCategory ? "top" : "child"}
            pathname={pathname}
            onLinkClick={onLinkClick}
            onLogout={onLogout}
          />
        </div>
      </ul>
    </>
  );
}
